<template>
  <div class="bottom-charts">
    <div v-if="showFlg" style="left: 40%; top: 30%; position: absolute">
      <dv-loading>Loading...</dv-loading>
    </div>
    <div class="key-select">
      <el-tag>{{$t('telemetryType')}}</el-tag>
      <el-select @change="selectProduct($event)" filterable v-model="selectDefault" :disabled = "showFlg">
        <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in selectBoards"></el-option>
      </el-select>
      <el-tag>{{$t('aggregation')}}</el-tag>
      <el-select @change="selectPolymerization($event)" filterable v-model="polymerizationSelect" :disabled = "showFlg">
        <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in polymerization"></el-option>
      </el-select>
    </div>
    <div class="time-select">
      <el-button @click="dayData" round :disabled = "showFlg">{{$t('day')}}</el-button>
      <el-button @click="weekData" round :disabled = "showFlg">{{$t('week')}}</el-button>
      <el-button @click="monthData" round :disabled = "showFlg">{{$t('month')}}</el-button>
      <el-date-picker @change="selectTime" :disabled = "showFlg" :end-placeholder="$t('endTime')" key="time" :range-separator="$t('to')" :start-placeholder="$t('startTime')"
                      type="datetimerange" v-model="value1"></el-date-picker>
      <el-button @click="exportData" round style=" float: right" :disabled = "showFlg">{{$t("export")}}</el-button>
    </div>
    <div class="left-num" >
      <p>{{cumulative}}：{{sum}}</p>
      <p>{{$t("avg")}}：{{avg}}</p>
    </div>
    <div class="middle-num">
      <p>{{$t('max')}}：{{max}}</p>
      <p>{{$t('min')}}：{{min}}</p>
    </div>
    <div class="right-num">
      <p>{{$t('timeInterval')}}：{{addNum}}</p>
      <p :style="evaporationDisplay()">{{$t("evaporation")}}：{{evaporationNum}}</p>
      <p :style="totalRadiationDisplay()">{{$t("sum")}}：{{totalRadiationNum}}</p>
      <p :style="cumFlowDisplay()">{{$t("cumFlow")}}：{{cumFlowSum}}</p>
    </div>
<!--    <dv-charts :option="option"/>-->
    <div class="chart" id="meteChart"></div>
  </div>
</template>

<script>
  import {getTimeDeviceHistory} from "../untils/api/home";
  import moment from "moment";

  export default {
    name: 'BottomChart',
    props: ["partInfo"],
    data() {
      return {
        option: {}, //样式
        selectBoards: [],// 遥测key
        selectDefault: '',//默认遥测key
        deviceId: {},//设备id
        dataArrList: [],//时间总数据
        valueArrList: [],//value 总数据
        name: '',//名称
        value1: [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")],
        startTime: '',
        endTime: '',
        telemetryKey: this.partInfo,
        exportList: [],
        totalRadiationList:[],
        polymerization: [
          {id: 1, name: this.$t('max')},
          {id: 2, name: this.$t('min')},
          {id: 3, name: this.$t('avg')},
        ],
        polymerizationSelect: 1,
        interval: 0,
        agg: '',
        showFlg: false,
        sum: 0,
        max: 0,
        min: 0,
        avg: 0,
        addNum: 0,
        evaporationNum: 0,
        totalRadiationNum: 0,
        cumFlowSum: 0,
        //errorNum: 0,
        unit: '',
        cumulative: '',
        dayFlg: true,
        TGFlg: false,
      }
    },
    watch: {
      partInfo() {
        this.telemetryKey = this.partInfo;
        this.setSelectKey();
      }
    },
    methods: {
      /**
       * 获取某个设备的遥测数据
       * @param deviceId
       * @param keyResponse
       */
      getSelectKey(deviceId, keyResponse) {
        if (keyResponse.length === 0) {
          //设备key 不存在所有变量清空
          //this.option = {};
          this.setEmptyMeteOption();
          this.selectBoards = [];
          this.selectDefault = '';
          this.deviceId = {};
          this.dataArrList = [];
          this.valueArrList = [];
          this.exportList = [];
          this.name = '';
          this.unit = '';
          this.startTime = '';
          this.endTime = '';
          this.value1 = [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")];
          this.max = 0;
          this.min = 0;
          this.avg = 0;
          this.sum = 0;
          this.addNum = 0;
          return;
        }
        this.selectBoards = []; //清空遥测key
        this.deviceId = deviceId;//设备id赋值
        this.startTime = '';
        this.endTime = '';
        this.value1 = [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")];
        this.polymerizationSelect = 1;
        this.interval = 0;
        this.max = 0;
        this.min = 0;
        this.avg = 0;
        this.sum = 0;
        this.addNum = 0;
        let pattern = /^[A-Za-z0-9.-_-]+$/;

        setTimeout(() => {
          console.log("5 秒后执行的操作");
          // 在这里执行你的逻辑
          let HIFlg = localStorage.getItem("HI") === "HI" ? true : false;
          this.TGFlg = localStorage.getItem("TG") === "TG" ? true : false;
          // key存在循环
          for (let i = 0; i < keyResponse.length; i++) {
            if (pattern.test(keyResponse[i])) {
              let linkName = {};
              linkName.id = keyResponse[i];
              linkName.name = this.$t(keyResponse[i]).split(',')[0];
              this.selectBoards.push(linkName);
              if(HIFlg == true && keyResponse[i] == 'ambientHumidity') {
                if(keyResponse.indexOf('ambientTemperature') !== -1) {
                  let HIJson = {};
                  HIJson.id = "HI";
                  HIJson.name = "热量指数";
                  this.selectBoards.push(HIJson);
                }
              }
              if(this.TGFlg == true && keyResponse[i] == 'ambientHumidity') {
                if(keyResponse.indexOf('ambientTemperature') !== -1) {
                  let HIJson = {};
                  HIJson.id = "AT";
                  HIJson.name = this.$t('AT').split(',')[0];
                  this.selectBoards.push(HIJson);
                }
              }
            }
          }
          if(this.TGFlg == true) {
            this.selectBoards.push(
              {id: 'WindGust', name: 'Wind gust'},
              {id: 'LSC', name: 'L.S.C'},
              {id: 'LAD', name: 'L.A.D'},
              {id: 'Vapor', name: 'Vapor'}
            );
          }

          //初期化选中第一条
          this.selectDefault = this.selectBoards[0].id;
          //根据key获取对应的历史value值
          this.getSelectValue();
        }, 50); // 5000 毫秒 = 5 秒
      },

      /**
       * 获取选中的key值
       * @param event
       */
      selectProduct(event) {
        console.log("选中的遥测key", event);
        this.selectDefault = event;
        //根据key获取对应的历史value值
        this.getSelectValue();
      },

      /**
       * 获取一天的历史记录
       */
      dayData() {
        this.value1 = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")];
        this.startTime = new Date(moment().subtract(1, "days")).getTime();
        this.endTime = new Date(moment()).getTime();
        // this.getSelectValue();
        //根据选中的聚合功能设置不同的值
        this.selectPolymerization(this.polymerizationSelect);
      },

      /**
       * 获取一周的历史记录
       */
      weekData() {
        this.value1 = [moment().subtract(7, "days").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")];
        this.startTime = new Date(moment().subtract(7, "days")).getTime();
        this.endTime = new Date(moment()).getTime();
        // this.getSelectValue();
        //根据选中的聚合功能设置不同的值
        this.selectPolymerization(this.polymerizationSelect);
      },

      /**
       * 获取一月的历史记录
       */
      monthData() {
        this.value1 = [moment().subtract(1, "months").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")];
        this.startTime = new Date(moment().subtract(1, "months")).getTime();
        this.endTime = new Date(moment()).getTime();
        // this.getSelectValue();
        //根据选中的聚合功能设置不同的值
        this.selectPolymerization(this.polymerizationSelect);
      },

      /**
       * 根据digital组件中选中的值获取一天的历史记录
       */
      setSelectKey() {
        if(this.telemetryKey == '热量指数') {
          this.selectDefault = 'HI';
        } else if(this.telemetryKey == 'AT') {
          this.selectDefault = 'AT';
        } else {
          this.selectDefault = this.telemetryKey[0].en;
        }
        this.dayData();
      },

      /**
       * 获取选中的时间
       * @param val
       */
      selectTime(val) {
        if (val === null) {
          this.value1 = [moment().format("YYYY-MM-DD HH:mm"), moment().subtract(-1, "days").format("YYYY-MM-DD HH:mm")];
          this.startTime = '';
          this.endTime = '';
        } else {
          //开始时间
          this.startTime = new Date(val[0]).getTime();
          //结束时间
          this.endTime = new Date(val[1]).getTime();
        }
        //设置样式
        // this.getSelectValue()
        //根据选中的聚合功能设置不同的值
        this.selectPolymerization(this.polymerizationSelect);
      },

      /**
       * 根据选中的聚合功能设置不同的值
       * @param event
       */
      selectPolymerization(event){
        this.polymerizationSelect = event;//将选中的聚合功能赋值
        let time = this.endTime - this.startTime; // 获取时间间隔
        if(time <= 1000 * 60 * 60 * 24){
          //时间间隔小于一天取出所有数据
          this.agg = 'NONE';
          this.interval = 0;
          this.dayFlg = true;
          //获取数据，设置样式
          this.getSelectValue();
        } else {
          this.dayFlg = false;
          switch (event) {
            case 1: //最大值
              this.agg = 'MAX';
              this.setInterval(); //设置聚合时间间隔
              this.getSelectValue(); //获取数据，设置样式
              break;
            case 2: //最小值
              this.agg = 'MIN';
              this.setInterval(); //设置聚合时间间隔
              this.getSelectValue(); //获取数据，设置样式
              break;
            case 3: // 平均值
              this.agg = 'AVG';
              this.setInterval(); //设置聚合时间间隔
              this.getSelectValue(); //获取数据，设置样式
              break;
          }
        }
      },

      /**
       * 设置聚合时间间隔
       */
      setInterval(){
        let intervalTime = (this.endTime - this.startTime) / (1000 * 60 * 60 * 24); //时间间隔天数
        if(intervalTime > 1 && intervalTime < 30){
          // 1天到30天 小于一个月时设置间隔时间
          this.setIntervalDay(intervalTime);
        } else if(intervalTime >= 30){
          // 30天以上 大于一个月时设置间隔时间
          this.setIntervalMonth(intervalTime);
        }
      },

      /**
       * 小于一个月时设置间隔时间
       * @param intervalDayTime
       */
      setIntervalDay(intervalDayTime){
        switch (true) {
          case intervalDayTime > 1 && intervalDayTime <= 3: //大于1天小于等于3天
            this.interval = 1000 * 60 * 10;
            break;
          case intervalDayTime > 3 && intervalDayTime <= 5: //大于3天小于等于5天
            this.interval = 1000 * 60 * 15;
            break;
          case intervalDayTime > 5 && intervalDayTime <= 10: //大于5天小于等于10天
            this.interval = 1000 * 60 * 30;
            break;
          case intervalDayTime > 10 && intervalDayTime <= 20: //大于10天小于等于20天
            this.interval = 1000 * 60 * 60;
            break;
          case intervalDayTime > 20: //大于20天
            this.interval = 1000 * 60 * 60 * 2;
            break;
        }
      },

      /**
       * 大于一个月时设置间隔时间
       * @param intervalDayTime
       */
      setIntervalMonth(intervalMonthTime){
        switch (true) {
          case intervalMonthTime === 30: //等于一个月
            this.interval = 1000 * 60 * 60 * 2;
            break;
          case intervalMonthTime > 30 && intervalMonthTime <= 90: //大于1个月小于3个月
            this.interval = 1000 * 60 * 60 * 5;
            break;
          case intervalMonthTime > 90 && intervalMonthTime <= 180: //大于3个月小于小于6个月
            this.interval = 1000 * 60 * 60 * 10;
            break;
          case intervalMonthTime > 180 && intervalMonthTime <= 240: //大于6个月小于小于8个月
            this.interval = 1000 * 60 * 60 * 12;
            break;
          case intervalMonthTime >= 240: //大于8个月
            this.interval = 1000 * 60 * 60 * 24;
            break;
        }

      },

      /**
       *根据key 获取value值
       * @param deviceId
       * @param key
       */
      getSelectValue() {
        //this.errorNum ++;
        //每次根据key获取对应的value值全部上次数据清空
        this.dataArrList = [];
        this.valueArrList = [];
        this.exportList = [];
        this.totalRadiationList = [];
        let day = '';
        let start = this.startTime === '' ? new Date(moment()).getTime() : this.startTime;//对开始时间赋值
        let end = this.endTime === '' ? new Date(moment().subtract(-1, "days")).getTime() : this.endTime;//对结束时间赋值
        let WDFlg = localStorage.getItem("WD") === "WD" ? true : false;
        //this.selectDefault === 'TotalRadiation' ? this.cumulative = this.$t("sunshine") : this.cumulative = this.$t("sum");
        if(this.selectDefault === 'TotalRadiation' || this.selectDefault === 'Radiation' || this.selectDefault === 'RadiationR' || this.selectDefault === 'RadiationV'
          || this.selectDefault === 'RadiationL' || this.selectDefault === 'Dradiation' || this.selectDefault === 'Sradiation' || this.selectDefault === 'Hradiation'
          || this.selectDefault === 'Radia' || this.selectDefault === 'TotalRadiation1' || this.selectDefault === 'TotalRadiation2' || this.selectDefault === 'Rad'
          || this.selectDefault === 'solarFlat' || this.selectDefault == 'solarAngle') {
          this.cumulative = this.$t("sunshine");
        } else {
          this.cumulative = this.$t("sum");
        }
        let param='';
        if(this.selectDefault == 'ammoniaIon') {
          param = 'ammoniaIon,waterPH,waterT';
        } else if(this.selectDefault == 'HI') {
          param = 'ambientHumidity,ambientTemperature';
        } else if(this.selectDefault == 'AT') {
          param = 'ambientTemperature,ambientHumidity,windSpeed';
        } else if(this.TGFlg == true && (this.selectDefault == 'WindGust' || this.selectDefault == 'LSC' || this.selectDefault == 'LAD' ||  this.selectDefault == 'Vapor')) {
          return;
        } else if(this.selectDefault == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
          param = 'level';
          this.interval = 1000 * 60 * 60;
          this.agg = 'AVG';
          this.polymerizationSelect = 3;
        } else {
          param = this.selectDefault;
        }
        //访问历史遥测api
        this.showFlg = true;
        getTimeDeviceHistory(this.deviceId.entityType, this.deviceId.id, param, start, end, this.interval, this.agg).then(response => {
          //this.errorNum = 0;
          //历史数据不存在
          if (JSON.stringify(response) == "{}") {
            this.dataArrList = [];
            this.valueArrList = [];
            //this.option = {};
            this.setEmptyMeteOption();
            this.showFlg = false;
            this.max = 0;
            this.min = 0;
            this.avg = 0;
            this.sum = 0;
            this.addNum = 0;
            this.evaporationNum = 0;
            this.cumFlowSum = 0;
          } else {
            if(this.selectDefault == 'ammoniaIon') {
              let changeResponse = [];
              let amnitroArray = response['ammoniaIon'];
              let waterPHArray = response['waterPH'];
              let waterTArray = response['waterT'];
              if(response.hasOwnProperty('waterPH') && waterPHArray.length > 0 ) {
                if(waterTArray.length > 0) {
                  let min = Math.min(
                    amnitroArray.length,
                    waterPHArray.length,
                    waterTArray.length
                  );
                  for(let i = 0; i < min; i++) {
                    let amnitroJson = {};
                    let amnitro = parseFloat(amnitroArray[i].value);
                    let waterPH = parseFloat(waterPHArray[i].value);
                    let waterT = parseFloat(waterTArray[i].value);
                    let result = amnitro * Math.pow(10, waterPH - (-0.032 * waterT + 10.042)) + amnitro;
                    let amnitroResult = result.toFixed(2);
                    amnitroJson.ts = amnitroArray[i].ts;
                    amnitroJson.value = amnitroResult;
                    changeResponse.push(amnitroJson);
                  }
                } else {
                  let min = Math.min(
                    amnitroArray.length,
                    waterPHArray.length
                  );
                  for(let i = 0; i < min; i++) {
                    let amnitroJson = {};
                    let amnitro = parseFloat(amnitroArray[i].value);
                    let waterPH = parseFloat(waterPHArray[i].value);
                    let result = amnitro * Math.pow(10, (waterPH - 9.25)) + amnitro;
                    let amnitroResult = result.toFixed(2);
                    amnitroJson.ts = amnitroArray[i].ts;
                    amnitroJson.value = amnitroResult;
                    changeResponse.push(amnitroJson);
                  }
                }
              } else {
                changeResponse = amnitroArray;
              }

              this.name = this.$t('ammoniaIon').split(',')[0];
              this.unit = this.$t('ammoniaIon').split(',')[1] === undefined ? '' : this.$t('ammoniaIon').split(',')[1];
              for(let i = 0; i < changeResponse.length; i++) {
                this.dataArrList.push(this.dateFormat(changeResponse[i].ts).substring(5));
                this.valueArrList.push(parseFloat(parseFloat(changeResponse[i].value).toString()));
                this.exportList.push({
                  ts: this.dateFormat(changeResponse[i].ts),
                  value: parseFloat(changeResponse[i].value).toString()
                });
              }

              //设置样式
              this.max = Math.max(...this.valueArrList).toFixed(2);
              this.min = Math.min(...this.valueArrList).toFixed(2);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              this.setEmptyMeteOption();
              this.setOption();
              this.showFlg = false;
            } else if(this.selectDefault == 'HI') {
              let HIResponse = [];
              let humArray = response['ambientHumidity'];
              let temArray = response['ambientTemperature'];
              let min = Math.min(
                humArray.length,
                temArray.length
              );

              for(let i = 0; i < min; i++) {
                let HIJson = {};
                let HI = this.calculateHeatIndex(parseFloat(temArray[i].value), parseFloat(humArray[i].value));
                HIJson.ts = humArray[i].ts;
                HIJson.value = HI;
                HIResponse.push(HIJson)
              }
              this.name = '热量指数';
              this.unit = '';
              for(let i = 0; i < HIResponse.length; i++) {
                this.dataArrList.push(this.dateFormat(HIResponse[i].ts).substring(5));
                this.valueArrList.push(parseFloat(parseFloat(HIResponse[i].value).toFixed(3)));
                this.exportList.push({
                  ts: this.dateFormat(HIResponse[i].ts),
                  value: parseFloat(HIResponse[i].value).toFixed(3)
                });
              }

              //设置样式
              this.max = Math.max(...this.valueArrList).toFixed(2);
              this.min = Math.min(...this.valueArrList).toFixed(2);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              this.setEmptyMeteOption();
              this.setOption();
              this.showFlg = false;
            } else if(this.selectDefault == 'AT') {
              let ATResponse = [];
              let temArray = response['ambientTemperature'];
              let humArray = response['ambientHumidity'];
              let speedArray = response['windSpeed'];
              if(temArray != undefined && humArray != undefined && speedArray != undefined) {
                let min = Math.min(
                  temArray.length,
                  humArray.length,
                  speedArray.length
                );
                for(let i = 0; i < min; i++) {
                  let ATJson = {};
                  let AT = this.calculateAT(parseFloat(temArray[i].value), parseFloat(humArray[i].value), parseFloat(speedArray[i].value));
                  ATJson.ts = temArray[i].ts;
                  ATJson.value = AT.toFixed(2);
                  ATResponse.push(ATJson)
                }

                this.name = this.$t('AT').split(',')[0];
                this.unit = this.$t('AT').split(',')[1] === undefined ? '' : this.$t('AT').split(',')[1];
                for(let i = 0; i < ATResponse.length; i++) {
                  this.dataArrList.push(this.dateFormat(ATResponse[i].ts).substring(5));
                  this.valueArrList.push(ATResponse[i].value);
                  this.exportList.push({
                    ts: this.dateFormat(ATResponse[i].ts),
                    value: ATResponse[i].value
                  });
                }
                //设置样式
                this.max = Math.max(...this.valueArrList).toFixed(2);
                this.min = Math.min(...this.valueArrList).toFixed(2);
                const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
                this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              }
              this.setEmptyMeteOption();
              this.setOption();
              this.showFlg = false;
            } else if(this.selectDefault == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
              this.cumFlowSum = 0;
              let cumSum = 0;
              for (let obj in response) {
                this.name = this.$t(obj).split(',')[0];
                this.$t(obj).split(',')[1] === undefined ? this.unit = '' : this.unit = this.$t(obj).split(',')[1];
                for (let i = 0; i < response[obj].length; i++) {
                  let levelNum = 0;
                  if(parseFloat(response[obj][i].value) < 0) {
                    levelNum = 0;
                  } else {
                    levelNum = parseFloat(response[obj][i].value);
                  }
                  cumSum += parseFloat(levelNum.toFixed(4)) * 2399.5;
                  this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                  this.valueArrList.push(parseFloat(parseFloat(response[obj][i].value).toFixed(4)));
                  this.exportList.push({
                    ts: this.dateFormat(response[obj][i].ts),
                    value: parseFloat(response[obj][i].value).toFixed(4)
                  });
                }
              }
              this.cumFlowSum = cumSum.toFixed(4);
              this.max = Math.max(...this.valueArrList).toFixed(2);
              this.min = Math.min(...this.valueArrList).toFixed(2);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              const getSum =  arr => arr.reduce(function(prev,curr,index,arr){return prev + curr;});
              this.sum  = parseFloat(getSum(this.valueArrList)).toFixed(2);
              this.setOption();
              this.showFlg = false;
            } else if(this.selectDefault == 'windDirection' && WDFlg == true ) {
              let directoryValueArrList = [];
              this.name = this.$t('windDirection').split(',')[0];
              for(let i = 0; i < response['windDirection'].length; i++) {
                this.dataArrList.push(this.dateFormat(response['windDirection'][i].ts).substring(5));
                this.valueArrList.push(response['windDirection'][i].value + ".0");
                directoryValueArrList.push(parseFloat(parseFloat(response['windDirection'][i].value).toString()));
                this.exportList.push({
                  ts: this.dateFormat(response['windDirection'][i].ts),
                  value: response['windDirection'][i].value + ".0"
                });
              }

              this.max = Math.max(...this.valueArrList).toFixed(1);
              this.min = Math.min(...this.valueArrList).toFixed(1);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(directoryValueArrList)).toFixed(1);
              this.setEmptyMeteOption();
              this.setOption();
              this.showFlg = false;
            } else {
              //历史数据存在，对dataArrList selectValueList重新赋值
              let levelRefer = localStorage.getItem('levelRefer');//获取设置的水位值
              let snowRefer = localStorage.getItem('snowRefer'); //获取设置雪深值
              let noiseRefer = localStorage.getItem('noiseRefer');//获取设置噪声值
              let CODJson =  localStorage.getItem('CODJson');//虚拟COD
              let min = null;
              let max = null;
              if(CODJson != "null") {
                let parsedCODJson = JSON.parse(CODJson);
                min = parsedCODJson.min;
                max = parsedCODJson.max;
              }
              for (let obj in response) {
                this.name = this.$t(obj).split(',')[0];
                this.$t(obj).split(',')[1] === undefined ? this.unit = '' : this.unit = this.$t(obj).split(',')[1];
                for (let i = 0; i < response[obj].length; i++) {
                  if(this.selectDefault == 'level' || this.selectDefault == 'Rwater' || this.selectDefault == 'waterlevel') { //当前为水位属性
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(Math.abs(parseFloat(levelRefer) +  parseFloat(response[obj][i].value)).toFixed(4).toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: Math.abs(parseFloat(levelRefer) + parseFloat(response[obj][i].value)).toString()
                    });
                  } else if(this.selectDefault == 'snowHeight' || this.selectDefault == 'snowheight') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(Math.abs(parseFloat(snowRefer) +  parseFloat(response[obj][i].value)).toFixed().toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: Math.abs(parseFloat(snowRefer) + parseFloat(response[obj][i].value)).toString()
                    })
                  } else if(this.selectDefault == 'noise' || this.selectDefault == 'noi' || this.selectDefault == 'noise1' || this.selectDefault == 'noise2') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(Math.abs(parseFloat(noiseRefer) +  parseFloat(response[obj][i].value)).toFixed(1).toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: Math.abs(parseFloat(noiseRefer) + parseFloat(response[obj][i].value)).toString()
                    })
                  } else if(this.selectDefault == 'flowNum') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push((parseFloat(response[obj][i].value) * 6.28).toFixed(2));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: (parseFloat(response[obj][i].value) * 6.28).toFixed(2)
                    })
                  } else if(this.selectDefault == 'Rday1') {
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat((parseFloat(response[obj][i].value) * 0.36).toFixed(2)));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: (parseFloat(response[obj][i].value) * 0.36).toFixed(2)
                    })
                  }  else if(this.selectDefault == 'COD') {
                    if(min != null && max != null) {
                      let num = this.calculateCOD(min, max, response[obj][i].value);
                      this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                      this.valueArrList.push(parseFloat(num));
                      this.exportList.push({
                        ts: this.dateFormat(response[obj][i].ts),
                        value: num
                      });
                    } else {
                      this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                      this.valueArrList.push(parseFloat(parseFloat(response[obj][i].value).toString()));
                      this.exportList.push({
                        ts: this.dateFormat(response[obj][i].ts),
                        value: parseFloat(response[obj][i].value).toString()
                      });
                    }

                  } else if(localStorage.getItem('waterFlg') == "water" && (this.selectDefault == 'Amnitro' || this.selectDefault == 'dissolvedoxygen'
                    || this.selectDefault == 'Opacity') || this.selectDefault == 'oRp') {
                    let num;
                    if(this.selectDefault == 'Amnitro') num = this.calculateWater(0,8,parseFloat(response[obj][i].value)).toFixed(2);
                    if(this.selectDefault == 'dissolvedoxygen') num = this.calculateWater(2,10,parseFloat(response[obj][i].value)).toFixed(2);
                    if(this.selectDefault == 'Opacity') num = this.calculateWater(251,1000,parseFloat(response[obj][i].value)).toFixed(0);
                    if(this.selectDefault == 'oRp') num = this.calculateWater(50,500, parseFloat(response[obj][i].value)).toFixed(0);
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(num));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: num
                    });
                  }  else { //非水位属性
                    this.dataArrList.push(this.dateFormat(response[obj][i].ts).substring(5));
                    this.valueArrList.push(parseFloat(parseFloat(response[obj][i].value).toString()));
                    this.exportList.push({
                      ts: this.dateFormat(response[obj][i].ts),
                      value: parseFloat(response[obj][i].value).toString()
                    });

                    this.totalRadiationList.push({
                      ts: response[obj][i].ts,
                      value: parseFloat(response[obj][i].value).toString()
                    })
                  }
                }
              }
              //设置样式
              this.max = Math.max(...this.valueArrList).toFixed(2);
              this.min = Math.min(...this.valueArrList).toFixed(2);
              const arrayAverage = arr => arr.reduce((acc, val) => acc + val, 0) / arr.length;
              this.avg  = parseFloat(arrayAverage(this.valueArrList)).toFixed(2);
              this.setLightnum();
              this.setEmptyMeteOption();
              this.getEvaporation();
              this.setOption();
              this.showFlg = false;
            }
          }
        }).catch(error => {
          this.max = 0;
          this.min = 0;
          this.avg = 0;
          this.sum = 0;
          this.addNum = 0;
          this.setEmptyMeteOption();
          this.showFlg = false;
          this.$message({
            showClose: true,
            type: "warning",
            message: "数据查询失败，请稍后再试"
          })
          console.log("error", error)
          // if(this.errorNum > 4){
          //   this.max = 0;
          //   this.min = 0;
          //   this.avg = 0;
          //   this.sum = 0;
          //   this.addNum = 0;
          //   this.errorNum = 0;
          //   //this.option = {};
          //   this.setEmptyMeteOption();
          //   this.showFlg = false;
          //   console.log("error", error)
          // } else {
          //   this.getSelectValue();
          // }

        })
      },

      calculateHeatIndex(T, RH) {
        // 系数定义
        const c1 = -42.379;
        const c2 = 2.04901523;
        const c3 = 10.14333127;
        const c4 = -0.22475541;
        const c5 = -0.00683783;
        const c6 = -0.05481717;
        const c7 = 0.00122874;
        const c8 = 0.00085282;
        const c9 = -0.00000199;

        // 热量指数计算
        let HI = c1 + (c2 * T) + (c3 * RH) + (c4 * T * RH) + (c5 * T * T) + (c6 * RH * RH) +
          (c7 * T * T * RH) + (c8 * T * RH * RH) + (c9 * T * T * RH * RH);

        return HI;
      },

      calculateAT(temp, hum, speed) {
        let e = hum/100*6.105*2.71828*17.27*temp/(237.7+temp);
        let AT = 1.07*temp+0.2*e-0.65*speed-2.7;
        return AT;
      },

      calculateCOD(min, max, value) {
        let result = value;
        if(value > max || value < min) {
          result = (Math.random() * (max - min) + min).toFixed(1);
        }
        return result
      },

      calculateWater(min, max, value) {
        value = Math.abs(value);
        if(value == 0) value += 1;
        if (value >= min && value <= max) {
          return value; // 直接返回原值
        }

        if (value < min) {
          let multiplier = 2;
          while (value < min) {
            value *= multiplier;
            if (value >= min) break;
            multiplier = Math.min(multiplier + 1, max / min); // 限制 multiplier 递增幅度
          }
        } else if (value > max) {
          let divisor = 2;
          while (value > max) {
            value /= divisor;
            if (value <= max) break;
            divisor = Math.min(divisor + 1, max / min); // 限制 divisor 递增幅度
          }
        }

        return Math.min(Math.max(value, min), max); // 确保最终值在区间内
      },

      /**
       * 设置累计值或者辐射日照实数
       */
      setLightnum() {
        //辐射日照时数
        if(this.selectDefault === 'TotalRadiation' || this.selectDefault === 'Radiation' || this.selectDefault === 'RadiationR' || this.selectDefault === 'RadiationV'
          || this.selectDefault === 'RadiationL' || this.selectDefault === 'Dradiation' || this.selectDefault === 'Sradiation' || this.selectDefault === 'Hradiation'
          || this.selectDefault === 'Radia' || this.selectDefault === 'TotalRadiation1' || this.selectDefault === 'TotalRadiation2' || this.selectDefault === 'Rad'
          || this.selectDefault === 'solarFlat' || this.selectDefault === 'solarAngle'){
          let timeStamp = 0;
          if(this.dayFlg){
            //一天内的总辐射值
            for(let i = 0; i < this.exportList.length -1; i++){
              if(this.exportList[i].value > 1.2) {
                timeStamp += new Date(this.exportList[i].ts).getTime() - new Date(this.exportList[i + 1].ts).getTime();
              }
            }
          } else {
            //聚合函数的总辐射
            for(let i = 1; i < this.exportList.length; i++){
              if(this.exportList[i].value > 1.2) {
                timeStamp += new Date(this.exportList[i].ts).getTime() - new Date(this.exportList[i - 1].ts).getTime();
              }
            }
          }
          this.addNum = 0;
          this.sum = parseFloat(timeStamp/(1000 * 60 * 60)).toFixed(2);
          //const getSum =  arr => arr.reduce(function(prev,curr,index,arr){return prev + curr;});
          //this.totalRadiationNum = parseFloat(getSum(this.valueArrList)).toFixed(2);
          this.getSumTotalRadiation();
        } else {
          let addSum = 0;
          //累计值
          const getSum =  arr => arr.reduce(function(prev,curr,index,arr){return prev + curr;});
          this.sum  = parseFloat(getSum(this.valueArrList)).toFixed(2);

          if(this.dayFlg){
            //一天内的时段值
            for(let i = 0; i < this.exportList.length -1; i++){
              addSum += this.exportList[i].value - this.exportList[i + 1].value;
            }
            this.addNum = parseFloat(addSum).toFixed(2);
          } else {
            //聚合函数的时段值
            for(let i = 1; i < this.exportList.length; i++){
              addSum+= this.exportList[i].value - this.exportList[i - 1].value;
            }
            this.addNum = parseFloat(addSum).toFixed(2);
          }
        }
      },

      //格式化时间戳
      dateFormat(timestamp) {
        if (timestamp && timestamp != "") {
          let dateStr = moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
          return dateStr;
        }
        return "-";
      },

      /**
       * 获取蒸发量的值
       */
      getEvaporation() {
        this.evaporationNum = 0;
        if(this.selectDefault === 'Evaporation'){
          let num = 0;
          if(this.dayFlg){
            for(let i = 0; i < this.valueArrList.length -1; i++){
              if(this.valueArrList[i] - this.valueArrList[i + 1] <= 0){
                num += -(this.valueArrList[i] - this.valueArrList[i + 1]);
              }
            }
            this.evaporationNum = parseFloat(num.toFixed(2));
          } else {
            for(let i = 1; i < this.valueArrList.length; i++){
              if(this.valueArrList[i] - this.valueArrList[i - 1] <= 0){
                num += -(this.valueArrList[i] - this.valueArrList[i - 1]);
              }
            }
            this.evaporationNum = parseFloat(num.toFixed(2));
          }
        }
      },

      /**
       * 蒸发量是否显示
       */
      evaporationDisplay(){
        if(this.selectDefault !== 'Evaporation'){
          return {
            display:'none'
          }
        }
      },

      /**
       * 获取总辐射累计值
       */
      getSumTotalRadiation() {
        if(this.endTime - this.startTime <= 1000 * 60 * 60 * 24) {
          this.totalRadiationList.sort(function (a, b) {
            return b.ts < a.ts ? 1 : -1
          });

          this.getTotalRadiationNum(60, this.totalRadiationList);
        }
        else {
          this.totalRadiationNum = 0;
          this.$message({
            showClose: true,
            type: "warning",
            message: "查看" + this.$t(this.selectDefault).split(",")[0] + "累计值，请选择24小时内的时间段"
          })
        }
      },

      /**
       * 间隔小于一小时的总辐射累计值
       * @param count
       * @param arr
       */
      getTotalRadiationNum(count, arr) {
        let index = 0;
        let arrTemp = [];
        let defaultTime = arr[0].ts;
        arrTemp.push([]);
        // 遍历原始数组
        for (let i = 0; i < arr.length; i++) {
          if(defaultTime + 1000 * 60 * 60 < arr[i].ts) {
            defaultTime = arr[i].ts;
            index++;
            arrTemp.push([]);
          }
          arrTemp[index].push(arr[i]);
        }

        let totalRadiation = 0;
        for(let i = 0; i < arrTemp.length; i++) {
          let totalSum = 0;
          for(let j = 0; j < arrTemp[i].length; j++) {
            totalSum += parseFloat(arrTemp[i][j].value) / 60;
          }
          totalRadiation += totalSum;
        }
        this.totalRadiationNum = parseFloat(totalRadiation).toFixed(2);
      },

      /**
       * 总辐射累计值是否显示
       */
      totalRadiationDisplay() {
        //TotalRadiation
        if(this.selectDefault == 'TotalRadiation' || this.selectDefault == 'Radiation' || this.selectDefault == 'RadiationR' || this.selectDefault == 'RadiationV'
          || this.selectDefault === 'RadiationL' || this.selectDefault === 'Dradiation' || this.selectDefault === 'Sradiation' || this.selectDefault === 'Hradiation'
          || this.selectDefault === 'Radia' || this.selectDefault === 'TotalRadiation1' || this.selectDefault === 'TotalRadiation2' || this.selectDefault === 'Rad'
          || this.selectDefault === 'solarFlat' || this.selectDefault === 'solarAngle'){
          return {
            display:'inline'
          }
        } else {
          return {
            display:'none'
          }
        }
      },

      cumFlowDisplay() {
        if(this.selectDefault == 'level' && localStorage.getItem('cumFlow') == 'cumFlow') {
          return {
            display:'inline'
          }
        } else {
          return {
            display:'none'
          }
        }
      },

      /**
       * 设置样式
       * @param name
       */
      setOption() {
        let that = this;
        this.option = {
          color: ['#FEC00A',],
          title: {
            text: this.name,
            left: 'center', //居中
            top:'45',
            textStyle: {
              color: '#ffffff',
              fontSize: 20,
              lineHeight: 35,
              fontWeight: 'normal'
            }
          },
          tooltip: { //提示框
            trigger: 'axis',
            backgroundColor: "rgba(128, 128, 128, 0.5)",
            borderWidth: 1, //边框宽度设置1
            borderColor: "rgba(49, 73, 99, 1)", //设置边框颜色
            borderRadius: 4,
            padding: 5,
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function(params) {
              if(that.name == '天气状况') {
                let time = params[0].axisValue; // 获取时间
                let value = '';
                switch (parseInt(params[0].data)) {
                  case 0:
                    value = "晴";
                    break;
                  case 16:
                    value = "大雨";
                    break;
                  case 17:
                    value = "中雨";
                    break;
                  case 18:
                    value = "小雨";
                    break;
                  case 32:
                    value = "大毛毛雨";
                    break;
                  case 33:
                    value = "中毛毛雨";
                    break;
                  case 34:
                    value = "小毛毛雨";
                    break;
                  case 50:
                    value = "大雪";
                    break;
                  case 51:
                    value = "中雪";
                    break;
                  case 52:
                    value = "小雪";
                    break;
                  case 64:
                    value = "烟";
                    break;
                  case 80:
                    value = "雾";
                    break;
                  case 96:
                    value = "冰雪或高空坠物";
                    break;
                  case 153:
                    value = "飞虫或异常遮挡";
                    break;
                }

                return that.$t('time') + '：' + time + '<br>' + that.$t('Weather') + '：' + value;
              } else {
                let time = params[0].axisValue; // 获取时间
                let value = params[0].data; // 获取数值

                return that.$t('time') + '：' + time + '<br>' + that.$t('value') + '：' + value;
              }
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '3%',
            top:'35%',
            containLabel: true //grid区域是否包含坐标轴的刻度标签
          },
          xAxis: {
            name: this.$t("time"),
            type: 'category', //坐标轴类型。
            boundaryGap: true, //坐标轴两边留白策略
            data: this.dataArrList,
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize :10//字体大小
              },
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                // color:'#3a4650'// rgb(2,121,253)
                color: 'rgba(231, 244, 255, 0.2)'
              }
            },
            axisTick: {
              show: false
            },
            nameTextStyle: {
              color: '#ffffff',
              fontSize: 10
            }
          },
          yAxis: {
            name: this.$t("value") + ' (' + this.unit + ')',
            type: 'value',
            nameTextStyle:{
              color:'#fff',
              fontSize :10//字体大小
            },
            show: true, //隐藏坐标
            axisLabel: { //y轴的坐标文字
              show: true, //不显示坐标控件
              textStyle: {
                color: '#fff', //文字的颜色
                fontSize :10//字体大小
              },
            },
            // max:this.max,//最大值
            // min:this.min,
            splitLine:{  //坐标在grid区域的分割线
              show: false,// 不显示网格
              lineStyle: { //设置分割线的样式(图表横线颜色)
                color: ['#153a8a'] //网格颜色
              }
            },
            axisLine:{//坐标轴轴线相关设置
              show :true,
              lineStyle:{
                color:'rgba(231, 244, 255, 0.2)'//#3a4650  rgb(2,121,253) #3a4650
              }
            },
            axisTick:{ //坐标轴刻度相关设置。
              show :false,
            },
          },
          series: [
            {
              type: 'line',
              data: this.valueArrList,
              symbolSize: 5,
              smooth: true,
              animationDuration: 1000,
              lineStyle:{
                color:'#FEC00A'
              },
              tooltip: { //提示框
                trigger: 'axis',
                axisPointer: { // 坐标轴指示器，坐标轴触发有效
                  type: 'line' // 默认为直线，可选为：'line' | 'shadow'
                },
              },
            },
          ],
          dataZoom: [
            {
              endValue: 15, //一次显示10个
              type: 'slider',//有滑动条
              show: false,//是否显示滑动条
              xAxisIndex: [0],//开始下标
              handleSize: 0,//滑动条的左右2个滑动条大小
              height: 20, //滑动条高度
              left: "0%",//左边距离
              right: "0%",//右边距离
              bottom: 0,//底部距离
              // borderColor: "#3a4650", //边框颜色
              borderColor: "#101f3e", //边框颜色
              fillerColor: "#4C7C98",//选中区域的背景色#345A7C#4878fe
              borderRadius: 5,//边框弧度
              //backgroundColor: "#1c2735",//未选区域中的背景色
              backgroundColor:'#0b2d4c',
              showDataShadow: false, //是否显示数据阴影
              showDetail:false,//拖动时是否显示数值
              realtime: true,// 是否实时更新
              filterMode: "filter",
            },
            {
              //左右滑动
              type: "inside",
              show: true,
              xAxisIndex: [0],
              start: 0,
              end: 100,
            }
          ]

        }
        this.meteCharts();//加载折线图
      },


      // setOption() {
      //   this.option = {
      //     title: {
      //       text: this.name + '  ' + this.$t("history"),
      //       offset: [-150, -20],
      //       style: {
      //         fill: '#ffffff',
      //       }
      //     },
      //     grid: {
      //       left: '5%',
      //       right: '5%',
      //       top: '40%'
      //     },
      //     xAxis: {
      //       name: this.$t("time"),
      //       data: this.dataArrList.slice(0, 25),
      //       axisLabel: {
      //         style: {
      //           rotate: -20,
      //           translate: [5, 15],
      //           fill: '#ffffff',
      //         }
      //       },
      //       axisTick: {
      //         show: false
      //       },
      //       nameTextStyle: {
      //         fill: '#ffffff',
      //         fontSize: 10
      //       }
      //     },
      //     yAxis: {
      //       name: this.$t("value") + ' (' + this.unit + ')',
      //       data: 'value',
      //       max: Math.max(...this.valueArrList.slice(0, 25)),
      //       min: Math.min(...this.valueArrList.slice(0, 25)),
      //       nameTextStyle: {
      //         fill: '#ffffff',
      //         fontSize: 10
      //       },
      //       axisLabel: {
      //         style: {
      //           fill: '#ffffff',
      //         }
      //       },
      //       splitLine: {
      //         show: false,
      //       }
      //     },
      //     smooth: true,
      //     animationCurve: 'easeOutCubic',
      //     style: {
      //       HoverCursor: 'pointer',
      //       formatter: {
      //         HoverCursor: 'pointer',
      //       }
      //     },
      //     series: [
      //       {
      //         data: this.valueArrList.slice(0, 25),
      //         type: 'line',
      //         label: {
      //           show: true,
      //           style: {
      //             fill: "#ffffff",
      //             fontSize: 12
      //           },
      //         },
      //         linePoint: {
      //           radius: 4,
      //           fill: '#f07c1e',
      //         },
      //         lineStyle: {
      //           lineWidth: 2,
      //           stroke: '#f07c1e'
      //         }
      //       }
      //     ]
      //
      //   };
      //   console.log("BottomChart", this.option);
      // },

      /**
       * 清空折线图
       */
      setEmptyMeteOption() {
        this.option = {};
        this.meteCharts();//加载折线图
      },

      /**
       * 折线图屏幕自适应
       */
      meteCharts(){
        document.getElementById("meteChart").removeAttribute("_echarts_instance_");
        let chartOption = this.$echarts.init(document.getElementById('meteChart'));
        chartOption.setOption(this.option);
        //图表自适应
        window.addEventListener("resize",function(){
          chartOption.resize()  // myChart 是实例对象
        })
      },

      /**
       * 导出当前显示的数据
       */
      exportData() {
        let that = this;
        if (that.exportList.length === 0) {
          // alert("该时间区间内没有数据，请重新选择");
          that.$message({
            showClose: true,
            type: "warning",
            message: that.$t("dataError")
          });
          return;
        }
        const {export_json_to_excel} = require('../vendor/Export2Excel');
        const tHeader = [this.$t("time"), this.$t("value"),];
        const filterVal = ['ts', 'value',];
        const list = that.exportList;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, this.name + " " +  this.$t("dataList"));

      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },
    }
  }
</script>

<style lang="less">
  @import "less/bottomChart";
</style>



// WEBPACK FOOTER //
// src/components/BottomChart.vue